import { request, METHOD } from "@/utils/request";
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

// 获取新着情报列表数据
export function getNewsList(data) {
  return request("".concat(BASE_URL) + "/news", METHOD.GET, data);
}

// 获取新着情报分类数据
export function getNewsCategory() {
  return request("".concat(BASE_URL) + "/news/categories", METHOD.GET);
}

// 更新新着情报状态
export function updateNews(data) {
  return request("".concat(BASE_URL) + "/news/status", METHOD.PUT, data);
}

// 新着情报详情
export function getNewsDetail(data) {
  return request("".concat(BASE_URL) + "/news/".concat(data.id), METHOD.GET, data);
}

// 保存新着情报
export function saveNews(data) {
  return request("".concat(BASE_URL) + "/news", METHOD.POST, data);
}

// 更新分类
export function updateCategory(data) {
  return request("".concat(BASE_URL) + "/news/categories", METHOD.POST, data);
}

// 删除分类
export function deleteCategory(data) {
  return request("".concat(BASE_URL) + "/news/categories/".concat(data.categoryId), METHOD.DELETE, data);
}